import React from "react";

// Settings card icon for Settings › Facilities — exported 1:1 from Figma (Facility Management,
// node I4036:28835;182:5936;241:3177;182:195, "Settings Icon / Icon=Facilities", 38×38).
const FacilityManagementIcon = ({ style = {} }) => {
  return (
    <svg style={style} width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M31.3669 4.67334H17.9807"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.3669 9.58643H17.9807"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="1.67329"
        cy="1.67329"
        r="1.67329"
        transform="matrix(-1 0 0 1 29.6936 7.91333)"
        fill="white"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="1.67329"
        cy="1.67329"
        r="1.67329"
        transform="matrix(-1 0 0 1 23.8372 3)"
        fill="white"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.65701 35.9987V20.9142C3.65701 20.5115 3.98734 20.1835 4.39586 20.1835H6.60971C6.80543 20.1835 6.99315 20.1068 7.13168 19.97C7.2702 19.8333 7.3482 19.6478 7.34856 19.4543V14.8292C7.34856 14.4252 7.67888 14.0986 8.0874 14.0986H18.9139C19.3211 14.0986 19.6514 14.4252 19.6514 14.8292V19.4529C19.6514 19.8556 19.9818 20.1822 20.3903 20.1822H22.6041C23.0127 20.1822 23.343 20.5102 23.343 20.9128V36M13.498 14.0972V12M25 35.9987H2M10.4806 31.3109L10.4833 31.3829M10.4806 27.0458L10.4833 27.1178M16.7271 31.3109L16.7244 31.3829M16.7271 27.0458L16.7244 27.1178M13.4993 20.5742V22.8007M13.4993 20.5742V18.3476M13.4993 20.5742H15.7496M13.4993 20.5742H11.2491"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FacilityManagementIcon;
